import {
  FcStatistics,
  FcNews,
  FcBullish,
  FcBearish,
  FcCalculator,
  FcShop,
} from "react-icons/fc";
import { IoScanSharp } from "react-icons/io5";
import { HiMenuAlt2 } from "react-icons/hi";
import { FaChevronRight } from "react-icons/fa";
import price_List from "../Assets/price_list.png";
import bank from "../Assets/bank.png";
import Expense from "../Assets/Expense.png";
import permission from "../Assets/persmissions.png";
import expense_head from "../Assets/ExpenseHead.png";
import CustomerPayment from "../Assets/CustomerPayment.png";
import SupplierPayment from "../Assets/SupplierPayment.png";
import transaction from "../Assets/transaction.png";
import journal from "../Assets/journal.png";
import PDCRecieveable from "../Assets/PDCRecieveable.png";
import PDCPayable from "../Assets/PDCPayable.png";
import Voucher from "../Assets/Voucher.png";
import MonthlyVoucher from "../Assets/MonthlyVoucher.png";
import CustomerVoucher from "../Assets/CustomerVoucher.png";
import SupplierVoucher from "../Assets/SupplierVoucher.png";
import AccountVoucher from "../Assets/AccountVoucher.png";
import Products from "../Assets/Products.png";
import Logs from "../Assets/Logs.png";
import User from "../Assets/user.png";
import Role from "../Assets/roles.png";
import Permissions from "../Assets/Permissions.png";
import glock from "../Assets/glock.png";
import { NavLink, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { usePermissions } from "../Utils/PermissionsContext";
// Icons
import dashboard from "../Assets/dashboard.png";
import quotation from "../Assets/quote.png";
import note from "../Assets/note.png";
import operation from "../Assets/operation.png";
import ImportList from "../Assets/ImportList.png";
import customers from "../Assets/customer.png";
import customerDetails from "../Assets/customerDetails.png";
import orders from "../Assets/orders.png";
import suppliers from "../Assets/supplier.png";
import supplierDetails from "../Assets/supplierDetails.png";
import purchaseOrder from "../Assets/purchaseOrder.png";
import management from "../Assets/management.png";
import warehouse from "../Assets/warehouse.png";
import pickingList from "../Assets/pickingList.png";
import packingList from "../Assets/packingList.png";
import locatio from "../Assets/location1.png";
import warehouseProducts from "../Assets/warehouseProducts.png";
import packedproducts from "../Assets/packedProducts.png";
import StockDetails from "../Assets/StockDetails.png";
import stockLedger from "../Assets/stockLedger.png";

import report from "../Assets/report.png";
import account from "../Assets/account.png";
import documentIcon from "../Assets/document.png";
import warehouseManagement from "../Assets/warehouse-management.png";

/* ── Smooth animated height dropdown ── */
const AnimatedDropdown = ({ isOpen, children }) => {
  const innerRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!innerRef.current) return;
    setHeight(isOpen ? innerRef.current.scrollHeight : 0);
  }, [isOpen]);

  // Also recalculate if children change (sub-submenus open inside)
  useEffect(() => {
    if (!innerRef.current || !isOpen) return;
    const observer = new ResizeObserver(() => {
      if (innerRef.current) setHeight(innerRef.current.scrollHeight);
    });
    observer.observe(innerRef.current);
    return () => observer.disconnect();
  }, [isOpen]);

  return (
    <div
      style={{
        height: `${height}px`,
        overflow: "hidden",
        transition: "height 280ms cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <div ref={innerRef}>{children}</div>
    </div>
  );
};

/* ── Tooltip for collapsed icons ── */
const Tooltip = ({ label, children }) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const [pos, setPos] = useState(0);

  const handleEnter = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (rect) setPos(rect.top + rect.height / 2);
    setShow(true);
  };

  return (
    <div
      ref={ref}
      className="relative w-full flex justify-center"
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <div
          className="fixed z-[9999] px-3 py-1.5 rounded-lg text-xs font-semibold
                     bg-gray-800 text-white shadow-xl whitespace-nowrap pointer-events-none"
          style={{ left: 76, top: pos, transform: "translateY(-50%)" }}
        >
          {label}
          <span
            className="absolute left-[-5px] top-1/2 -translate-y-1/2 w-0 h-0
                       border-t-[5px] border-t-transparent
                       border-b-[5px] border-b-transparent
                       border-r-[5px] border-r-gray-800"
          />
        </div>
      )}
    </div>
  );
};

/* ── Floating popup submenu for collapsed mode ── */
const FloatingMenu = ({ items, top, onClose }) => {
  const ref = useRef();
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="fixed z-[9999] bg-white border border-gray-200 rounded-xl shadow-2xl py-1.5 min-w-[190px]"
      style={{ top, left: 76 }}
    >
      {items.map((subItem, i) => (
        <div key={i}>
          {subItem.subMenu ? (
            <div className="px-2 pt-2 pb-1">
              <p className="text-[10px] uppercase tracking-widest text-gray-400 font-bold px-2 mb-1">
                {subItem.name}
              </p>
              {subItem.subMenu.map((nested, ni) => (
                <NavLink
                  key={ni}
                  to={nested.path}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors duration-150 ${
                      isActive
                        ? "bg-indigo-50 text-indigo-700"
                        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                    }`
                  }
                >
                  <span className="shrink-0">{nested.icon}</span>
                  {nested.name}
                </NavLink>
              ))}
            </div>
          ) : (
            <NavLink
              to={subItem.path}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-4 py-2 text-xs font-medium transition-colors duration-150 ${
                  isActive
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                }`
              }
            >
              <span className="shrink-0">{subItem.icon}</span>
              {subItem.name}
            </NavLink>
          )}
        </div>
      ))}
    </div>
  );
};

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);
  const [floatingMenu, setFloatingMenu] = useState(null);
  const itemRefs = useRef({});

  const toggle = () => {
    setIsOpen((prev) => !prev);
    setFloatingMenu(null);
  };

  const handleDropdownToggle = (index) => {
    setActiveDropdown((prev) => (prev === index ? null : index));
    setActiveSubDropdown(null);
  };

  const handleSubDropdownToggle = (index) => {
    setActiveSubDropdown((prev) => (prev === index ? null : index));
  };

  const handleCollapsedClick = (index, item) => {
    if (!item.sub) return;
    const rect = itemRefs.current[index]?.getBoundingClientRect();
    setFloatingMenu((prev) =>
      prev?.index === index
        ? null
        : { index, top: rect?.top ?? 0, items: item.subMenu },
    );
  };

  const { permissions } = usePermissions();
  const Show = (name) => {
    const obj = permissions?.find((p) => p.name === name);
    return !!obj?.read;
  };

  const menuItems = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: (
        <img
          src={dashboard}
          alt="Dashboard"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: false,
    },
    {
      name: "Price List ",
      path: "/pricelist",
      icon: (
        <img
          src={price_List}
          alt="Price List"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: false,
    },
    {
      name: "Customers",
      path: "/customers",
      icon: (
        <img
          src={customers}
          alt="Customers"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: true,
      subMenu: [
        {
          name: "Quotation",
          path: "/quotation",
          icon: (
            <img
              src={quotation}
              alt="Quotation"
              style={{ width: 16, height: 16 }}
            />
          ),
          sub: false,
        },
        {
          name: "Customer Details",
          path: "/customers",
          icon: (
            <img
              src={customerDetails}
              alt="CustomersDetails"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Orders",
          path: "/order",
          icon: (
            <img src={orders} alt="Orders" style={{ width: 16, height: 16 }} />
          ),
        },
      ],
    },
    {
      name: "Suppliers",
      path: "/suppliers",
      icon: (
        <img src={suppliers} alt="Supplier" style={{ width: 16, height: 16 }} />
      ),
      sub: true,
      subMenu: [
        {
          name: "Supplier Details",
          path: "/suppliers",
          icon: (
            <img
              src={supplierDetails}
              alt="Supplier Details"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Purchase Order",
          path: "/purchase",
          icon: (
            <img
              src={purchaseOrder}
              alt="Purchase Order"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
      ],
    },
    {
      name: "Warehouse Management",
      path: "/warehouse",
      icon: (
        <img
          src={warehouseManagement}
          alt="WarehouseManagement"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: true,
      subMenu: [
        {
          name: "Warehouse",
          path: "/warehouse",
          icon: (
            <img
              src={warehouse}
              alt="Warehouse"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Picking List",
          path: "/pickinglist",
          icon: (
            <img
              src={pickingList}
              alt="Picking List"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Packing List",
          path: "/packinglist",
          icon: (
            <img
              src={packingList}
              alt="Packing List"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Location",
          path: "/location",
          icon: (
            <img
              src={locatio}
              alt="Location"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Warehouse Products",
          path: "/scannedproducts",
          icon: (
            <img
              src={warehouseProducts}
              alt="Warehouse Products"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Packed Products",
          path: "/packedproducts",
          icon: (
            <img
              src={packedproducts}
              alt="Packed Products"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Stock Ledger",
          path: "/stockledger",
          icon: (
            <img
              src={stockLedger}
              alt="Stock Ledger"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
      ],
    },
    {
      name: "Accounts",
      path: "/accounts",
      icon: (
        <img src={account} alt="Supplier" style={{ width: 16, height: 16 }} />
      ),
      sub: true,
      subMenu: [
        {
          name: "Bank Accounts",
          path: "/accounts",
          icon: (
            <img src={bank} alt="Supplier" style={{ width: 16, height: 16 }} />
          ),
        },
        {
          name: "Expenses",
          path: "/expenses",
          icon: <img src={Expense} alt="" style={{ width: 16, height: 16 }} />,
        },
        {
          name: "Expenses Head",
          path: "/expenses/head",
          icon: (
            <img
              src={expense_head}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Customer Payments",
          path: "/incomes",
          icon: (
            <img
              src={CustomerPayment}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Supplier Payments",
          path: "/supplierpayments",
          icon: (
            <img
              src={SupplierPayment}
              alt="CustomersDetails"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Transactions",
          path: "/transactions",
          icon: (
            <img
              src={transaction}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Journal",
          path: "/journals",
          icon: (
            <img
              src={journal}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Closing Voucher",
          path: "/monthly/voucher",
          icon: (
            <img
              src={Voucher}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
          sub: true,
          subMenu: [
            {
              name: "Monthly Voucher",
              path: "/monthly/voucher",
              icon: (
                <img
                  src={MonthlyVoucher}
                  alt="Supplier"
                  style={{ width: 16, height: 16 }}
                />
              ),
            },
            {
              name: "Customer Voucher",
              path: "/monthly/customerVoucher",
              icon: (
                <img
                  src={CustomerVoucher}
                  alt="Supplier"
                  style={{ width: 16, height: 16 }}
                />
              ),
            },
            {
              name: "Supplier Voucher",
              path: "/monthly/suppliervoucher",
              icon: (
                <img
                  src={SupplierVoucher}
                  alt="Supplier"
                  style={{ width: 16, height: 16 }}
                />
              ),
            },
            {
              name: "Accounts Voucher",
              path: "/monthly/accountsvoucher",
              icon: (
                <img
                  src={AccountVoucher}
                  alt="Supplier"
                  style={{ width: 16, height: 16 }}
                />
              ),
            },
          ],
        },
        {
          name: "PDC Payable",
          path: "/payable",
          icon: (
            <img
              src={PDCPayable}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "PDC Receiveable",
          path: "/receiveable",
          icon: (
            <img
              src={PDCRecieveable}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
      ],
    },
    {
      name: "Report",
      path: "/stockdetails",
      icon: <img src={report} alt="Report" style={{ width: 16, height: 16 }} />,
      sub: true,
      subMenu: [
        {
          name: "Stock Details",
          path: "/stockdetails",
          icon: (
            <img
              src={StockDetails}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Stock Ledger",
          path: "/stockledger",
          icon: (
            <img
              src={stockLedger}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
      ],
    },
    {
      name: "Operations",
      path: "/importlist",
      icon: (
        <img
          src={operation}
          alt="Operations"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: true,
      subMenu: [
        {
          name: "Import List",
          path: "/importproducts",
          icon: (
            <img
              src={ImportList}
              alt="ImportList"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Products",
          path: "/products",
          icon: (
            <img
              src={Products}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
      ],
    },
    {
      name: "Management",
      path: "/managemet",
      icon: (
        <img
          src={management}
          alt="Management"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: true,
      subMenu: [
        {
          name: "Users",
          path: "/users",
          icon: (
            <img
              src={User}
              alt="Management"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Roles",
          path: "/roles",
          icon: (
            <img src={Role} alt="Supplier" style={{ width: 16, height: 16 }} />
          ),
        },
        {
          name: "Permissions",
          path: "/permission",
          icon: (
            <img
              src={Permissions}
              alt="Supplier"
              style={{ width: 16, height: 16 }}
            />
          ),
        },
        {
          name: "Logs",
          path: "/logs",
          icon: (
            <img src={Logs} alt="Supplier" style={{ width: 16, height: 16 }} />
          ),
        },
      ],
    },
    {
      name: "Inventory",
      path: "/inventory",
      icon: (
        <img
          src={permission}
          alt="Supplier"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: false,
    },
    {
      name: "Documents",
      path: "/document",
      icon: (
        <img
          src={documentIcon}
          alt="Document"
          style={{ width: 16, height: 16 }}
        />
      ),
      sub: false,
    },
    {
      name: "Notes",
      path: "/notes",
      icon: <img src={note} alt="Notes" style={{ width: 16, height: 16 }} />,
      sub: false,
    },
  ];

  const location = useLocation();

  return (
    <div>
      {location.pathname === "/login" ? (
        children
      ) : (
        <div className="flex min-h-screen bg-gray-50">
          {/* ── Sidebar ── */}
          <aside
            style={{
              width: isOpen ? "240px" : "68px",
              transition: "width 280ms cubic-bezier(0.4, 0, 0.2, 1)",
            }}
            className="fixed left-0 top-0 h-screen z-50 flex flex-col
                       bg-white border-r border-gray-200 shadow-sm overflow-hidden"
          >
            {/* ── Header ── */}
            <div
              className="flex items-center h-16 px-3 bg-black shrink-0 border-b border-gray-100"
              style={{ justifyContent: isOpen ? "space-between" : "center" }}
            >
              <div
                style={{
                  opacity: isOpen ? 1 : 0,
                  maxWidth: isOpen ? "160px" : "0px",
                  overflow: "hidden",
                  transition:
                    "opacity 200ms ease, max-width 280ms cubic-bezier(0.4,0,0.2,1)",
                  whiteSpace: "nowrap",
                }}
              >
                <img
                  src={glock}
                  alt="Logo"
                  className="h-8 w-auto object-contain"
                />
              </div>

              <button
                onClick={toggle}
                className="p-2 rounded-lg text-gray-300 hover:text-gray-100
                           hover:bg-white/20 transition-colors duration-150 shrink-0"
              >
                <HiMenuAlt2 className="text-xl" />
              </button>
            </div>

            {/* ── Nav ── */}
            <nav
              className="flex-1 overflow-y-auto py-3 px-2 space-y-0.5"
              style={{ overflowX: "hidden" }}
            >
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className={Show(item.name) ? "block" : "hidden"}
                >
                  {/* ── COLLAPSED ── */}
                  {!isOpen ? (
                    <Tooltip label={item.name}>
                      <div
                        ref={(el) => (itemRefs.current[index] = el)}
                        className="w-full"
                      >
                        {item.sub ? (
                          <button
                            onClick={() => handleCollapsedClick(index, item)}
                            className={`flex items-center justify-center w-full p-2.5 rounded-lg transition-colors duration-150
                              ${
                                floatingMenu?.index === index
                                  ? "bg-gray-100 text-black"
                                  : "text-gray-500 hover:bg-gray-100 hover:text-gray-900"
                              }`}
                          >
                            <span className="text-base">{item.icon}</span>
                          </button>
                        ) : (
                          <NavLink
                            to={item.path}
                            className={({ isActive }) =>
                              `flex items-center justify-center w-full p-2.5 rounded-lg transition-colors duration-150
                              ${
                                isActive
                                  ? "bg-gray-100 text-black"
                                  : "text-gray-500 hover:bg-gray-100 hover:text-gray-900"
                              }`
                            }
                          >
                            <span className="text-base">{item.icon}</span>
                          </NavLink>
                        )}
                      </div>
                    </Tooltip>
                  ) : (
                    /* ── EXPANDED ── */
                    <>
                      {item.sub ? (
                        <button
                          onClick={() => handleDropdownToggle(index)}
                          className={`flex items-center gap-2.5 w-full px-3 py-2.5 rounded-xl text-left
                                      transition-colors duration-150
                                      ${
                                        activeDropdown === index
                                          ? "bg-gray-100 text-gray-900"
                                          : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
                                      }`}
                        >
                          <span className="shrink-0 text-base">
                            {item.icon}
                          </span>
                          <span className="flex-1 text-xs font-semibold truncate">
                            {item.name}
                          </span>
                          <FaChevronRight
                            size={10}
                            className="shrink-0 text-gray-400"
                            style={{
                              transform:
                                activeDropdown === index
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                              transition:
                                "transform 250ms cubic-bezier(0.4,0,0.2,1)",
                            }}
                          />
                        </button>
                      ) : (
                        <NavLink
                          to={item.path}
                          className={({ isActive }) =>
                            `flex items-center gap-2.5 w-full px-3 py-2.5 rounded-md transition-colors duration-150
                            ${
                              isActive
                                ? "bg-gray-100 text-black"
                                : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
                            }`
                          }
                        >
                          <span className="shrink-0 text-base">
                            {item.icon}
                          </span>
                          <span className="text-xs font-semibold truncate">
                            {item.name}
                          </span>
                        </NavLink>
                      )}

                      {/* Animated submenu */}
                      <AnimatedDropdown
                        isOpen={!!(item.sub && activeDropdown === index)}
                      >
                        <div className="mt-1 ml-3 pl-3 border-l-2 border-gray-100 space-y-0.5 pb-1">
                          {item.subMenu?.map((subItem, subIndex) => (
                            <div key={subIndex}>
                              {subItem.subMenu ? (
                                <>
                                  <button
                                    onClick={() =>
                                      handleSubDropdownToggle(subIndex)
                                    }
                                    className={`flex items-center gap-2 w-full px-3 py-2 rounded-lg text-left
                                                transition-colors duration-150
                                                ${
                                                  activeSubDropdown === subIndex
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
                                                }`}
                                  >
                                    <span className="shrink-0 text-sm">
                                      {subItem.icon}
                                    </span>
                                    <span className="flex-1 text-xs font-medium truncate">
                                      {subItem.name}
                                    </span>
                                    <FaChevronRight
                                      size={9}
                                      className="shrink-0 text-gray-400"
                                      style={{
                                        transform:
                                          activeSubDropdown === subIndex
                                            ? "rotate(90deg)"
                                            : "rotate(0deg)",
                                        transition:
                                          "transform 250ms cubic-bezier(0.4,0,0.2,1)",
                                      }}
                                    />
                                  </button>

                                  {/* Animated nested sub-submenu */}
                                  <AnimatedDropdown
                                    isOpen={activeSubDropdown === subIndex}
                                  >
                                    <div className="ml-3 pl-3 border-l-2 border-gray-100 mt-0.5 space-y-0.5 pb-1">
                                      {subItem.subMenu.map(
                                        (nestedItem, nestedIndex) => (
                                          <NavLink
                                            key={nestedIndex}
                                            to={nestedItem.path}
                                            className={({ isActive }) =>
                                              `flex items-center gap-2 px-3 py-1.5 rounded-lg transition-colors duration-150
                                            ${
                                              isActive
                                                ? "bg-indigo-50 text-indigo-700"
                                                : "text-gray-400 hover:bg-gray-50 hover:text-gray-800"
                                            }`
                                            }
                                          >
                                            <span className="shrink-0 text-xs">
                                              {nestedItem.icon}
                                            </span>
                                            <span className="text-[11px] font-medium truncate">
                                              {nestedItem.name}
                                            </span>
                                          </NavLink>
                                        ),
                                      )}
                                    </div>
                                  </AnimatedDropdown>
                                </>
                              ) : (
                                <NavLink
                                  to={subItem.path}
                                  className={({ isActive }) =>
                                    `flex items-center gap-2 px-3 py-2 rounded-lg transition-colors duration-150
                                    ${
                                      isActive
                                        ? "bg-indigo-50 text-indigo-700"
                                        : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
                                    }`
                                  }
                                >
                                  <span className="shrink-0 text-sm">
                                    {subItem.icon}
                                  </span>
                                  <span className="text-xs font-medium truncate">
                                    {subItem.name}
                                  </span>
                                </NavLink>
                              )}
                            </div>
                          ))}
                        </div>
                      </AnimatedDropdown>
                    </>
                  )}
                </div>
              ))}
            </nav>
          </aside>

          {/* ── Floating popup for collapsed mode ── */}
          {!isOpen && floatingMenu && (
            <FloatingMenu
              items={floatingMenu.items}
              top={floatingMenu.top}
              onClose={() => setFloatingMenu(null)}
            />
          )}

          {/* ── Main content ── */}
          <main
            style={{
              marginLeft: isOpen ? "240px" : "68px",
              transition: "margin-left 280ms cubic-bezier(0.4, 0, 0.2, 1)",
            }}
            className="flex-1 min-h-screen bg-gray-50"
          >
            <div className="p-5">{children}</div>
          </main>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
